import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/Router";
import { initializeTheme } from "@/features/theme/theme";
import { installChunkReloadHandler } from "@/lib/chunkReload";
import "@fontsource-variable/geist";
import "@/styles/global.css";

initializeTheme();
installChunkReloadHandler();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
